// extracted by mini-css-extract-plugin
export var wrapper = "ColumnsWrapper-module--wrapper--3EiqR";
export var columns = "ColumnsWrapper-module--columns--3WXJO";